// extracted by mini-css-extract-plugin
export var productImage = "_qo-1";
export var viewLink = "_qo-2";
export var wishlistItem = "_qo-0";